import { Grid } from "@mui/material";
import { useContext, useState } from "react";

import { GlobalAlertContext } from "../../contexts/GlobalAlertContext";

import React from "react";
import CardSys from "../../components/cardSys";
import TitlePages from "../../components/generic/titlePages";
import ButtonSave from "../../components/buttonSave";
import { api } from "../../services/api";
import CancelButton from "../../components/generic/cancelButton";
import InputPasswordProfile from "../../components/generic/inputPassWordProfile";
import { LangContext } from "../../contexts/LangContext";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../contexts/AuthContext";
import BoxTheme from "../../components/generic/box";

export default function EditPassword() {
  const [currentPassword, setCurrentPassword] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setPasswordConfirm] = useState("");

  const { lang } = useContext(LangContext);

  const { handleLoading, handleToast } = useContext(GlobalAlertContext);
  const { user: userLogged, getUser } = useContext(AuthContext)

  const navigate = useNavigate();

  const handleUpdate = async (event) => {
    event.preventDefault();
    if (currentPassword == "") {
      handleToast(true, "error", "Digite a senha antiga");
      return;
    }
    if (password == "") {
      handleToast(true, "error", "Digite a nova senha");
      return;
    }
    if (confirmPassword == "") {
      handleToast(true, "error", "Confirme a nova senha");
      return;
    }
    handleLoading(true);
    try {
      const { data } = await api({
        method: "PUT",
        url: "/user/password/" + userLogged?.id,
        data: {
          currentPassword,
          password,
          confirmPassword
        },
      });
      setCurrentPassword("")
      setPassword("")
      setPasswordConfirm("")
      handleToast(true, data.toast, data.message);
    } catch (err) {
      handleToast(true, err.response.data.toast, err.response.data.message);
    }
    handleLoading(false);
    getUser()
  };
  return (
    <>
      <Grid container sx={{ marginBottom: "16px" }}>
        <Grid item>
          <TitlePages>Trocar senha</TitlePages>
        </Grid>
      </Grid>
      <CardSys >
        <BoxTheme component="form"
          noValidate
          autoComplete="off"
          onSubmit={handleUpdate}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            <Grid
              item
              xs={4}
              direction="row"
              justifyContent="center"
              alignItems="center"
            >
              <InputPasswordProfile
                label={lang.components.generic.input__current_password_label}
                value={currentPassword}
                onChange={({ target }) => setCurrentPassword(target.value)}
              ></InputPasswordProfile>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{ display: "flex", marginTop: "64px" }}
              direction="row"
              justifyContent="center"
              alignItems="center"
            ></Grid>
          </Grid>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            <Grid
              item
              xs={4}
              direction="row"
              justifyContent="center"
              alignItems="center"
            >
              <InputPasswordProfile
                label={lang.components.generic.input_password_label}
                value={password}
                onChange={({ target }) => setPassword(target.value)}
              ></InputPasswordProfile>
            </Grid>
          </Grid>

          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            <Grid
              item
              sx={{ display: "flex", marginTop: "28px" }}
              xs={4}
              direction="row"
              justifyContent="center"
              alignItems="center"
            >
              <InputPasswordProfile
                label={lang.components.generic.input_confirm_password_label}
                value={confirmPassword}
                onChange={({ target }) => setPasswordConfirm(target.value)}
              ></InputPasswordProfile>
            </Grid>
          </Grid>
          <Grid
            container
            sx={{ marginTop: "48px", display: "flex", textTransform: 'initial' }}
            direction="row"
            justifyContent="center"
            alignItems="center"


          >
          </Grid>
          <Grid
            container
            sx={{ marginTop: "136px", display: "flex" }}
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            <Grid item>
              <CancelButton onClick={() => navigate("/profile")}></CancelButton>
            </Grid>
            <Grid item>
              <ButtonSave onClick={handleUpdate} sx={{ borderRadius: "0.7rem", color: 'white', textTransform: "initial" }}>Salvar</ButtonSave>
            </Grid>
          </Grid>
        </BoxTheme>
      </CardSys>
    </>
  );
}
